import React from 'react';
import PropTypes from 'prop-types';

export default class Dashboard extends React.Component{

    componentWillUnmount() {
        if (this.props.remountComponent) {
            this.props.remountComponent();
        }
    }

    render() {

        const debug = window.location.pathname.toLowerCase().includes("debug")
        debug && console.log ('Dashboard.js render Dashboard, props=', this.props);

        const dashboardUrl = new URL(window.location.origin + this.props.dashboardUrl);
        //prefix with kibana
        dashboardUrl.hostname = `kibana.${dashboardUrl.hostname}`;

        console.log('dashboardUrl =', dashboardUrl.toString());

        return(
            <div align="center" style={{height: '100%'}}>
                <iframe
                    title={"Dashboard"}
                    src={dashboardUrl.toString()}
                    style={{ display:'block', width:'100%', height: '100vh'}}
                />
            </div>
        )
    }
};

Dashboard.propTypes = {
    dashboardUrl: PropTypes.string.isRequired,
    remountComponent: PropTypes.func.isRequired
};